import DebugUANC from '../../core/version/debug';

export default () => {
    const { UANC } = window.Inpl.Ad;

    function signalGooglefcPresent() {
        if (!(window.frames as any)['googlefcPresent']) {
            if (document.body) {
                const iframe = document.createElement('iframe');
                iframe.style.width = '0px';
                iframe.style.height = '0px';
                iframe.style.border = 'none';
                iframe.style.zIndex = '-1000';
                iframe.style.left = '-1000px';
                iframe.style.top = '-1000px';
                iframe.style.display = 'none';
                iframe.name = 'googlefcPresent';
                document.body.appendChild(iframe);
            } else {
                setTimeout(signalGooglefcPresent, 0);
            }
        }
    }
    signalGooglefcPresent();

    // maxRetries - ilość razy sprawdzania dostępności
    const waitForGooglefc = (maxRetries: number) => {
        if (typeof window.googlefc !== 'undefined' && typeof window.googlefc.getAdBlockerStatus === 'function') {
            const adBlockerStatus = window.googlefc.getAdBlockerStatus();
            UANC?.setState({ isAdBlockDetect: adBlockerStatus !== 3 });
        } else if (maxRetries > 0) {
            setTimeout(() => waitForGooglefc(maxRetries - 1), 100);
        } else {
            UANC instanceof DebugUANC && UANC.warn('[AdBlock popup] googlefc.getAdBlockerStatus() is not available.');
        }
    };

    const script = document.createElement('script');
    script.src = 'https://fundingchoicesmessages.google.com/i/pub-1636271870028934?ers=1';
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
        waitForGooglefc(10);
    };

    document.head.appendChild(script);
};
